// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.mjs";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.bs.mjs";
import Format from "date-fns/format";
import IsToday from "date-fns/isToday";
import IsTomorrow from "date-fns/isTomorrow";
import * as Translation$LumiI18n from "lumi-i18n/lib/es6/src/Translation.bs.mjs";

function translate(locale, entry) {
  switch (locale) {
    case "ENG" :
        if (typeof entry !== "object") {
          switch (entry) {
            case "Bike" :
                return "Bike";
            case "Car" :
                return "Car";
            case "FreePlaces" :
                return "Free places";
            case "Location" :
                return "Location";
            case "LowerPlaces" :
                return "Lower places";
            case "OccupiedPlaces" :
                return "Occupied places";
            case "Open247" :
                return "Open: 24/7";
            case "OpenUntilLaterAt" :
            case "OpenUntilTodayAt" :
                return "Open until: ";
            case "OpenUntilTomorrowAt" :
                return "Open until: tomorrow ";
            case "OpensLaterAt" :
                return "Opens on: ";
            case "OpensTodayAt" :
                return "Opens at: ";
            case "OpensTomorrowAt" :
                return "Opens: tomorrow at ";
            case "Route" :
                return "Route";
            case "UpperPlaces" :
                return "Bovenplaatsen";
            case "Website" :
                return "Website";
            
          }
        } else {
          switch (entry.TAG) {
            case "Capacity" :
                return "Capacity: " + entry._0.toString();
            case "FacilityState" :
                var tmp = entry._0;
                if (typeof tmp !== "object") {
                  switch (tmp) {
                    case "Busy" :
                        return "Busy";
                    case "Closed" :
                        return "Closed";
                    case "Full" :
                        return "Full";
                    case "Open" :
                        return "Open";
                    
                  }
                } else {
                  tmp.TAG === "Free";
                }
                break;
            case "OpenUntil" :
            case "OpensAt" :
                break;
            
          }
        }
        break;
    case "FRA" :
        if (typeof entry !== "object") {
          switch (entry) {
            case "Bike" :
                return "Vélo";
            case "Car" :
                return "Auto";
            case "FreePlaces" :
                return "Places libres";
            case "Location" :
                return "Emplacement";
            case "LowerPlaces" :
                return "Places supérieures";
            case "OccupiedPlaces" :
                return "Places occupées";
            case "Open247" :
                return "Ouvert: 24/7";
            case "OpenUntilLaterAt" :
            case "OpenUntilTodayAt" :
                return "Ouvert jusqu'à: ";
            case "OpenUntilTomorrowAt" :
                return "Ouvert jusqu'à: demain à ";
            case "OpensLaterAt" :
                return "Ouvre le: ";
            case "OpensTodayAt" :
                return "Ouvre à: ";
            case "OpensTomorrowAt" :
                return "Ouvre: demain à ";
            case "Route" :
                return "Route";
            case "UpperPlaces" :
                return "Places inférieurs";
            case "Website" :
                return "Website";
            
          }
        } else {
          switch (entry.TAG) {
            case "Capacity" :
                return "Capacité: " + entry._0.toString();
            case "FacilityState" :
                var tmp$1 = entry._0;
                if (typeof tmp$1 !== "object") {
                  switch (tmp$1) {
                    case "Busy" :
                        return "Animé";
                    case "Closed" :
                        return "Fermé";
                    case "Full" :
                        return "Complet";
                    case "Open" :
                        return "Ouvert";
                    
                  }
                } else {
                  tmp$1.TAG === "Free";
                }
                break;
            case "OpenUntil" :
            case "OpensAt" :
                break;
            
          }
        }
        break;
    case "NLD" :
        if (typeof entry !== "object") {
          switch (entry) {
            case "Bike" :
                return "Fiets";
            case "Car" :
                return "Auto";
            case "FreePlaces" :
                return "Vrije plaatsen";
            case "Location" :
                return "Locatie";
            case "LowerPlaces" :
                return "Benedenplaatsen";
            case "OccupiedPlaces" :
                return "Bezette plaatsen";
            case "Open247" :
                return "Open: 24/7";
            case "OpenUntilLaterAt" :
            case "OpenUntilTodayAt" :
                return "Open tot: ";
            case "OpenUntilTomorrowAt" :
                return "Open tot: morgen om ";
            case "OpensLaterAt" :
                return "Opent op: ";
            case "OpensTodayAt" :
                return "Opent om: ";
            case "OpensTomorrowAt" :
                return "Opent: morgen om ";
            case "Route" :
                return "Route";
            case "UpperPlaces" :
                return "Bovenplaatsen";
            case "Website" :
                return "Website";
            
          }
        } else {
          switch (entry.TAG) {
            case "Capacity" :
                return "Capaciteit: " + entry._0.toString();
            case "FacilityState" :
                var tmp$2 = entry._0;
                if (typeof tmp$2 !== "object") {
                  switch (tmp$2) {
                    case "Busy" :
                        return "Druk";
                    case "Closed" :
                        return "Gesloten";
                    case "Full" :
                        return "Vol";
                    case "Open" :
                        return "Open";
                    
                  }
                } else {
                  tmp$2.TAG === "Free";
                }
                break;
            case "OpenUntil" :
            case "OpensAt" :
                break;
            
          }
        }
        break;
    default:
      
  }
  if (typeof entry !== "object") {
    return ;
  }
  switch (entry.TAG) {
    case "FacilityState" :
        var message = entry._0;
        if (typeof message !== "object") {
          return ;
        } else if (message.TAG === "Free") {
          return message._0.toString();
        } else {
          return message._0;
        }
    case "OpenUntil" :
        var time = entry._0;
        if (IsToday(time)) {
          return Core__Option.map(translate(locale, "OpenUntilTodayAt"), (function (s) {
                        return s + Format(time, "HH:mm", {
                                    locale: Caml_option.some(Locale$LumiI18n.toDateFnsLocale(locale))
                                  });
                      }));
        } else if (IsTomorrow(time)) {
          return Core__Option.map(translate(locale, "OpenUntilTomorrowAt"), (function (s) {
                        return s + Format(time, "HH:mm", {
                                    locale: Caml_option.some(Locale$LumiI18n.toDateFnsLocale(locale))
                                  });
                      }));
        } else {
          return Core__Option.map(translate(locale, "OpenUntilLaterAt"), (function (s) {
                        return s + Format(time, "eee d MMM HH:mm", {
                                    locale: Caml_option.some(Locale$LumiI18n.toDateFnsLocale(locale))
                                  });
                      }));
        }
    case "OpensAt" :
        var time$1 = entry._0;
        if (IsToday(time$1)) {
          return Core__Option.map(translate(locale, "OpensTodayAt"), (function (s) {
                        return s + Format(time$1, "HH:mm", {
                                    locale: Caml_option.some(Locale$LumiI18n.toDateFnsLocale(locale))
                                  });
                      }));
        } else if (IsTomorrow(time$1)) {
          return Core__Option.map(translate(locale, "OpensTomorrowAt"), (function (s) {
                        return s + Format(time$1, "HH:mm", {
                                    locale: Caml_option.some(Locale$LumiI18n.toDateFnsLocale(locale))
                                  });
                      }));
        } else {
          return Core__Option.map(translate(locale, "OpensLaterAt"), (function (s) {
                        return s + Format(time$1, "eee d MMM HH:mm", {
                                    locale: Caml_option.some(Locale$LumiI18n.toDateFnsLocale(locale))
                                  });
                      }));
        }
    default:
      return ;
  }
}

var Provider = Translation$LumiI18n.MakeProvider({
      defaultLocale: "ENG",
      translate: translate
    });

export {
  Provider ,
}
/* Provider Not a pure module */
